import { useCallback } from 'react';
import { useIsMobileLayout } from '../../components/styles/responsive';
import type { StoreFrontTabsParams } from '../../flows/storeFront/StoreFrontPageContent';
import { useRootNavigation } from '../navigation/PopNavigatorProvider';

export const useNavigateToStorefront = (options?: { replace?: boolean }) => {
  const navigation = useRootNavigation();
  const isMobile = useIsMobileLayout();

  return useCallback(
    (params?: { screen?: keyof StoreFrontTabsParams }, modal?: boolean) => {
      params = {
        screen: 'main',
        params: params ?? {},
      } as any;

      if (!isMobile || modal) {
        if (options?.replace) {
          navigation.replace('storefront', params as any);
        } else {
          navigation.navigate('storefront', params as any);
        }
        return;
      }

      // do mobile navigation.
      let nav = navigation;
      let max = 5;

      while (nav != null && max-- > 0) {
        const state = nav.getState();
        __DEV__ && console.log(state.routeNames[state.index]);
        if (state.routeNames.includes('debugPanel')) {
          break;
        }
        nav = nav.getParent();
      }

      nav?.navigate('home', {
        screen: 'user',
        params: params ?? {},
      });
    },
    [isMobile, navigation, options?.replace],
  );
};
